var exports = {
  "Z": "x0a7806d5--390de8--layout",
};

module.exports = exports;
